import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import site from '../../config/site';

export default function Seo({ title, description, image, children }) {
  const { pathname } = useLocation();
  const url = `${site.siteUrl}${pathname}`;

  const fullTitle = title
    ? (title.includes('SIESA') || title.includes('Soluciones e Integraciones Eléctricas')
        ? title
        : `${title} | SIESA Panamá`)
    : 'Soluciones e Integraciones Eléctricas S.A. | Panamá';

  return (
    <Helmet>
      <html lang="es" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Soluciones e Integraciones Eléctricas S.A." />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="es_PA" />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {children}
    </Helmet>
  );
}
